var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Floating Help"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 494",
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#EBEDEF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messages-bubble-question"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.988 11.9563C20.2588 11.9495 15.8983 14.5115 13.5988 18.648C11.2993 22.7845 11.423 27.8441 13.9217 31.8631C13.9217 31.8631 14.6552 32.9255 15.8692 34.1407C17.0833 35.356 18.1301 36.0755 18.1301 36.0755C22.8288 39.0009 28.8608 38.6369 33.1743 35.1676C37.4879 31.6984 39.1421 25.8806 37.3 20.6577C35.458 15.4348 30.5214 11.9459 24.988 11.9563Z",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M24.7106 29.9878C24.4805 29.9878 24.2939 30.1743 24.2939 30.4045C24.2939 30.6346 24.4805 30.8211 24.7106 30.8211C24.9407 30.8211 25.1273 30.6346 25.1273 30.4045C25.1273 30.1743 24.9407 29.9878 24.7106 29.9878",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M21.377 23.0433C21.377 21.2023 22.8693 19.71 24.7103 19.71C26.5512 19.71 28.0436 21.2023 28.0436 23.0433C28.0436 24.8842 26.5512 26.3766 24.7103 26.3766",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkRed);
export default __webpack_public_path__ + "static/media/QuestionMarkRed.fcc93d838715bdc5b779baeccf62c21c.svg";
export { ForwardRef as ReactComponent };